import { CadorDocumentReference } from './cador-document-reference';
import { ImpFoehnRecapSection } from './imp-foehn-recap-section';

export class Attachments {

    listeDocuments: CadorDocumentReference[] = [];
    recap: ImpFoehnRecapSection[] = [];

}
